import config from 'config'

const resourceUrl = `${config.resourceHost}dunning`

export default {
  resourceUrl,
  settingsUrl: `${resourceUrl}/setting`,
  preview: `${resourceUrl}/preview`,
}
